<template>
  <c-horizontal-schedule />
</template>
<script>
import CHorizontalSchedule from '../../components/CHorizontalScheduler.vue';

export default {
  components: {
    CHorizontalSchedule
  }
}
</script>